<template>
  <div class="home">
    <QueryForm  @blurrySearch="blurrySearch" ref="queryModal"/>
    <TableList  ref="table"/>
  </div>
</template>

<script>
import QueryForm from '@/components/users/IndentPage/QueryForm.vue'
import TableList from '@/components/users/IndentPage/TableList.vue'
import {
  queryCertificate,
  deteleCertificateList,
  categoryForCert,
  selectCompany,
} from '@/api/certificate'
import qs from 'qs'

import { burlywood } from 'color-name'
export default {
  name: 'product',
  components: { QueryForm, TableList },
  data() {
    return {
      pagination:'',
      params: {
        state:'',
        page: 1,
        size: 10,
        blurry:'',
      },
      blurry:'',
      total:null,
    }
  },
  mounted() {
    this.blurry=''
    this.queryList()

  },
  methods: {
    /**
     * 模糊搜索
     */
    blurrySearch(blurry) {
      this.blurry = blurry
      this.pagination.current = 1
      this.queryList()
    },

    
    /**
     * 列表搜索
     */
    async queryList() {
      this.$refs.table.loading =true;
      this.$refs.table.loading =false;
    },
    
  }
}
</script>

<style lang="less" scoped>
.home {
  min-height: 100%;
  // background-color: #fff;
  // padding: 15px;
  .modalTags{
    margin-borrom:8px;
  }
}
</style>
